module.exports = __webpack_public_path__ + "img/unknown.e3b1b3d8.png";